var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-header"}},[_c('h1',[_vm._v(_vm._s(_vm.headerText))]),_c('SortByMenu',_vm._g(_vm._b({},'SortByMenu',_vm.$props,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }